import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import { Tooltip } from "react-tooltip";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import { convertirFechaInputMonth } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";
var ps;

function Rendimientoinstalaciones(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [instalaciones, setInstalaciones] = useState([]);
  const [instalacionesCopy, setInstalacionesCopy] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fechaHoy, setFechaHoy] = useState(new Date());

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  const fetchInstalaciones = async (consulta = "&ultimo_mes=0") => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/admins/productionPerformance?id_huerta=" + huerta + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      if (data?.code == 200) {
        setInstalaciones([...data.data]);
        setInstalacionesCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchInstalaciones();
  }, [huerta]);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let est = 0.95;

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let mes = event.target.ultimoMes.value;
    let consulta = `&ultimo_mes=${mes}`;
    fetchInstalaciones(consulta);
  };

  const headers = [
    [
      "Parámetro",
      "Instalación",
      "Titular",
      "Potencia Pico",
      `Producción`,
      "Periodo",
    ],
  ];
  const headersTable = [
    { name: "Parámetro", prop: "parametro" },
    { name: "Instalación", prop: "numInstalacion" },
    { name: `Titular`, prop: "titular" },
    { name: "Potencia Pico", prop: "potPico" },
    { name: "Producción", prop: "produccion" },
    { name: "Periodo", prop: "periodo" },
  ];

  const properties = [
    "parametro",
    "numInstalacion",
    "titular",
    "potPico",
    "produccion",
    "periodo",
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div>
            <form onSubmit={handleSubmitForm}>
              <label className="d-flex justify-content-center align-items-center">
                <span
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Para obtener información del último mes entonces colocar 0, si quieres información de hace dos meses entonces coloca 1"
                  className="mdi mdi-information"
                ></span>
                <Tooltip
                  className="w-25 text-center"
                  place="bottom"
                  id="my-tooltip"
                />
                Ultimo mes:
                <input
                  name="ultimoMes"
                  defaultValue={0}
                  className="ml-1 mr-1"
                  type="number"
                  min={0}
                  max={11}
                />
                <button className="btn btn-primary btn-noPadding">
                  Enviar
                </button>
              </label>
            </form>
          </div>
          {!error && (
            <DataTableAvantSolar
              data={instalaciones}
              dataCopy={instalacionesCopy}
              setData={setInstalaciones}
              titleProps={
                "Rendimiento Instalaciones - Huerta: " +
                obtenerNombreHuertaId(huerta)
              }
              headers={headers}
              headersTable={headersTable}
              name={"rendimientoInstalaciones"}
              properties={properties}
              filtros={["numInstalacion", "titular"]}
              placeholderInput={"Filtra por Titular o Número de instalación"}
              defaultMostrar={40}
              loading={loading}
            ></DataTableAvantSolar>
          )}
          {error && <Alert message={error} />}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Rendimientoinstalaciones;
